(() => {
  if (customElements.get('finch-collection-description')) return;

  class FinchCollectionDescription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.content = this.querySelector('[data-fcd-content]');
      this.toggle = this.querySelector('[data-fcd-toggle]');
      this.toggleLabel = this.querySelector('[data-fcd-toggle-label]');
      this.expanded = false;

      if (!this.content || !this.toggle || this.dataset.collapsible !== 'true') return;

      this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
      this.handleHashChange = () => {
        if (window.location.hash === '#CollectionDescription') this.setExpanded(true);
      };
      window.addEventListener('hashchange', this.handleHashChange);
      this.resizeObserver = new ResizeObserver(() => this.queueMeasurement());
      this.resizeObserver.observe(this);

      this.queueMeasurement();
      document.fonts?.ready.then(() => {
        this.queueMeasurement();
        this.handleHashChange();
      });
    }

    disconnectedCallback() {
      if (this.handleHashChange) window.removeEventListener('hashchange', this.handleHashChange);
      this.resizeObserver?.disconnect();
      if (this.measurementFrame) cancelAnimationFrame(this.measurementFrame);
    }

    queueMeasurement() {
      if (this.measurementFrame) return;
      this.measurementFrame = requestAnimationFrame(() => {
        this.measurementFrame = null;
        this.measureOverflow();
      });
    }

    measureOverflow() {
      const collapsedHeight = Number.parseFloat(getComputedStyle(this).getPropertyValue('--fcd-collapsed-height'));
      const shouldCollapse = Number.isFinite(collapsedHeight) && this.content.scrollHeight > collapsedHeight + 8;

      this.classList.toggle('is-collapsible', shouldCollapse);
      if (!shouldCollapse) this.setExpanded(false);
    }

    setExpanded(expanded) {
      if (expanded && this.dataset.collapsible !== 'true') return;
      if (expanded && !this.classList.contains('is-collapsible')) this.measureOverflow();
      if (!this.classList.contains('is-collapsible') && expanded) return;

      this.expanded = expanded;
      this.classList.toggle('is-expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggleLabel.textContent = expanded
        ? this.dataset.expandedLabel || 'Bekijk minder'
        : this.dataset.collapsedLabel || 'Bekijk meer';
    }
  }

  customElements.define('finch-collection-description', FinchCollectionDescription);
})();
